var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customize-line-group"},[_c('div',{staticClass:"line"},[_vm._t("line")],2),_vm._v(" "),_c('div',{staticClass:"extra"},[_vm._t("extra")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3775c416","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./build/loaders/resource-error-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewComponents/CustomizeLineGroup/CustomizeLineGroup.vue
// module id = null
// module chunks = 